import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Text } from '@fragments';
import { IconSparkles } from '@tabler/icons-react';
import PlanName from '../../../../components/PlanName';
import { planAllows } from '../../../../enums/automations';

// The upgrade mark on an option above the creator's plan (`plan_gates`). The option still works in
// a draft, and shows in the preview; activating is what asks for the plan. Inside something that is
// already a button (a template card), `label` draws only the plan's name.
export default function PlanMark({ studio: s, required, label = false }) {
  const { t } = useTranslation('studioAutomations');
  if (!required || planAllows(s.payments.plan, required)) return null;
  const name = t(`studio:planName_${required}`);
  if (label) return <Text.caption><PlanName>{name}</PlanName></Text.caption>;
  return <Button className="studio-automation-plan-mark" size="micro" variant="rounded" color="ai" startIcon={<IconSparkles />} preventLoading
    tooltip={t('planMarkTooltip', { plan: name })} onClick={event => { event.stopPropagation(); s.automations.upgrade(required); }}>{name}</Button>;
}
